import { render } from "./switch-client.vue?vue&type=template&id=57099498&scoped=true&ts=true"
import script from "./switch-client.vue?vue&type=script&lang=ts"
export * from "./switch-client.vue?vue&type=script&lang=ts"

import "./switch-client.vue?vue&type=style&index=0&id=57099498&scoped=true&lang=stylus"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57099498"]])

export default __exports__